import {useContext, useState} from 'react';
import UserContext from './userContext';

export const useUserState = () => {
  const [user, _setUser] = useState(null);

  const setUser = user => {
    const hasPerm = perm => user.permissions.includes(perm);
    const u = {
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      permissions: {
        canReadEmployees: hasPerm('CAN_READ_EMPLOYEES'),
        canManageEmployees: hasPerm('CAN_MANAGE_EMPLOYEES'),
        canReadPto: hasPerm('CAN_READ_PTO'),
        canManagePto: hasPerm('CAN_MANAGE_PTO'),
        canSyncTopgrading: hasPerm('CAN_SYNC_TOPGRADING'),
        canExportTopgrading: hasPerm('CAN_EXPORT_TOPGRADING'),
        canViewScheduled: hasPerm('CAN_VIEW_SCHEDULED'),
        canManageScheduled: hasPerm('CAN_MANAGE_SCHEDULED'),
        canViewD365: hasPerm('CAN_VIEW_D365'),
        canManageD365: hasPerm('CAN_MANAGE_D365'),
        canViewHours: hasPerm('CAN_VIEW_HOURS'),
        canManageHours: hasPerm('CAN_MANAGE_HOURS'),
        canViewHourLogPeriods: hasPerm('CAN_VIEW_HOUR_LOG_PERIODS'),
        canViewExpenses: hasPerm('CAN_VIEW_EXPENSES'),
        canManageExpenses: hasPerm('CAN_MANAGE_EXPENSES'),
        canViewRates: hasPerm('CAN_VIEW_RATES'),
        canManageRates: hasPerm('CAN_MANAGE_RATES'),
        canViewWorkers: hasPerm('CAN_VIEW_WORKERS'),
        canManageWorkers: hasPerm('CAN_MANAGE_WORKERS'),
        canManageLiftoff: hasPerm('CAN_MANAGE_LIFTOFF'),
        canReadLoa: hasPerm('CAN_READ_LOA'),
        canManageLoa: hasPerm('CAN_MANAGE_LOA')
      }
    };
    _setUser(u);
  };

  return [user, setUser];
};

export const useUser = () => {
  const {user} = useContext(UserContext);
  return user;
};

export const useUserPermissions = () => {
  const u = useUser();
  if (u !== null) {
    return u.permissions;
  } else {
    return null;
  }
};
